import { render, staticRenderFns } from "./BridgeMaintenanceCostView.vue?vue&type=template&id=2f4ef5cd"
import script from "./BridgeMaintenanceCostView.vue?vue&type=script&lang=ts"
export * from "./BridgeMaintenanceCostView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports